import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Paper from '@mui/material/Paper';
import FormHelperText from '@mui/material/FormHelperText';

const ProductionCategoriesForm = ({ state, updateField, errors, productions, pc_type }) => {
    return (
        <Box p={4} display="flex" justifyContent="center">
            <Grid container spacing={1}>

                {/* Production ID Dropdown */}
                <Grid item xs={12} sm={12} >
                    <FormControl fullWidth size="small" error={!!errors.p_id} margin="normal">
                        <InputLabel id="prod-label">Παραγωγή</InputLabel>
                        <Select
                            labelId="prod-label"
                            id="prod-id"
                            label="Παραγωγή"
                            value={state?.p_id || ""}
                            onChange={e => updateField("p_id", e.target.value)}
                            MenuProps={{
                                PaperProps: {
                                    elevation: 2,
                                },
                            }}
                        >
                            {productions?.map(prod => (
                                <MenuItem key={prod.id} value={prod.id}>{prod.p_descr}</MenuItem>
                            ))}
                        </Select>
                        {errors.p_id && <FormHelperText>{errors.p_id}</FormHelperText>}
                    </FormControl>
                </Grid>

                {/* Category Type Dropdown */}
                <Grid item xs={12} sm={12} >
                    <FormControl fullWidth size="small" error={!!errors.pc_type_id} margin="normal">
                        <InputLabel id="category-type-label">Είδος Κατηγορίας</InputLabel>
                        <Select
                            labelId="category-type-label"
                            id="pc-type-id"
                            label="Είδος Κατηγορίας"
                            value={state?.pc_type_id || ""}
                            onChange={e => updateField("pc_type_id", e.target.value)}
                            MenuProps={{
                                PaperProps: {
                                    elevation: 2,
                                },
                            }}
                        >
                            {pc_type?.map(type => (
                                <MenuItem key={type.id} value={type.id}>{type.pct_descr}</MenuItem>
                            ))}
                        </Select>
                        {errors.pc_type_id && <FormHelperText>{errors.pc_type_id}</FormHelperText>}
                    </FormControl>
                </Grid>

                {/* Category Description */}
                <Grid item xs={12} sm={12}>
                    <TextField
                        margin="normal"
                        fullWidth
                        label="Περιγραφή"
                        value={state?.pc_descr || ""}
                        onChange={e => updateField("pc_descr", e.target.value)}
                        error={!!errors.pc_descr}
                        helperText={errors.pc_descr}
                    />
                </Grid>

                {/* Production Category AA */}
                <Grid item xs={12} sm={12}>
                    <TextField
                        fullWidth
                        label="AA"
                        value={state?.p_aa || ""}
                        onChange={e => updateField("p_aa", Number(e.target.value))}
                        error={!!errors.p_aa}
                        helperText={errors.p_aa}
                    />
                </Grid>

                {/* Category Notes */}
                <Grid item xs={12} sm={12}>
                    <TextField
                        fullWidth
                        label="Σημειώσεις"
                        value={state?.pc_notes || ""}
                        onChange={e => updateField("pc_notes", e.target.value)}
                        error={!!errors.pc_notes}
                        helperText={errors.pc_notes}
                        multiline
                        minRows={4}
                        maxRows={6}
                    />
                </Grid>

            </Grid>
        </Box>
    );
};

export default ProductionCategoriesForm;
